/**
 * PRO INPUT BÁSICO (value default = String)
 * mixins (docs) => https://br.vuejs.org/v2/guide/mixins.html
 */
import validator from './utils/validator.js';

export default {
  data() {
    return {
      message: '',
      listeners: '',
      internalLoading: false,
    };
  },
  created() {
    delete this.$listeners.input;
    this.listeners = this.$listeners;
  },

  props: {
    id: String,

    required: {},
    label: String,
    internalLabel: String,
    value: { type: String, default: '' },
    name: String,

    showLoad: { type: Boolean, default: false },
    info: String,
    icon: String,
    min: Number,
    max: Number,

    formValidation: { default: true },
    call: {},
    disabled: {},
    autocomplete: String,
    placeholder: {
      type: String,
      default: '',
    },
    customMessage: { type: String, default: '' },
    errorStyle: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    collapseDescription: { type: Boolean, default: false },
  },
  mixins: [validator],

  watch: {
    customMessage: {
      handler(newV) {
        this._isValid(this.model);
      },
    },
  },
  computed: {
    model: {
      get() {
        if (!this.value && String(this.value) !== 'false') return '';
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this._isValid(val);
      },
    },
    isValid() {
      return this._isValid(this.model);
    },
  },

  methods: {
    /**
         * VALIDAÇÕES ATUALIZANDO O MESSAGE
         */
    _isValid(val) {
      if (!_.isUndefined(this.required)) return this.updateMessage(this.isBlank(val));
      return this.updateMessage(this.isMinorThan(val, this.min));
    },
    updateMessage(msg) {
      this.message = '';
      if (!msg) return true;

      this.message = msg;
      return false;
    },
    getValue(o) {
      if (!_.isUndefined(o.value)) return o.value;
      return o;
    },
    getLabel(o) {
      if (!_.isUndefined(o.label)) return o.label;
      return o;
    },
    isLoading() {
      if (!_.isUndefined(this.call)) {
        if (this.showLoad) this.internalLoading = true;
        return this.call.isPending();
      }
      this.internalLoading = false;
      return false;
    },
    isDisabled() {
      if ((!_.isUndefined(this.disabled) && this.disabled !== false) || this.disabled === true) return true;
      return false;
    },

    focus() {
      const { input } = this.$refs;

      if (input) {
        if (typeof input.focus === 'function')
          input.focus();
        else if (input.$el && typeof input.$el.focus === 'function')
          input.$el.focus();
      }
    },
  },
};
